module.exports = __webpack_public_path__ + "static/img/digtal6.05f42bf.png";


//////////////////
// WEBPACK FOOTER
// ./public/visualImg/digtal6.png
// module id = 8n+4
// module chunks = 0